import { render, staticRenderFns } from "./product_centers.vue?vue&type=template&id=7b000cb3"
import script from "./product_centers.vue?vue&type=script&lang=js"
export * from "./product_centers.vue?vue&type=script&lang=js"
import style0 from "./product_centers.vue?vue&type=style&index=0&id=7b000cb3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports